// extracted by mini-css-extract-plugin
export var actions = "Support-module--actions--b191b";
export var atTopPage = "Support-module--atTopPage--6c393";
export var ctaSection = "Support-module--ctaSection--6779e";
export var extendedMenuSection = "Support-module--extendedMenuSection--941a5";
export var globalSearch = "Support-module--globalSearch--b7169";
export var languageSwitcher = "Support-module--languageSwitcher--09398";
export var logoSection = "Support-module--logoSection--64210";
export var mobileCascadeMenu = "Support-module--mobileCascadeMenu--a14a1";
export var mobileCascadeMenuHolder = "Support-module--mobileCascadeMenuHolder--80dc6";
export var mobileMenu = "Support-module--mobileMenu--cc6f7";
export var scrolling = "Support-module--scrolling--02c4a";
export var tkAktivGrotesk = "Support-module--tk-aktiv-grotesk--7d40f";
export var tkAktivGroteskCondensed = "Support-module--tk-aktiv-grotesk-condensed--655b7";
export var tkAktivGroteskExtended = "Support-module--tk-aktiv-grotesk-extended--33405";
export var tkAktivGroteskThin = "Support-module--tk-aktiv-grotesk-thin--8479d";
export var tkNeuzeitGrotesk = "Support-module--tk-neuzeit-grotesk--695ce";
export var tkNeuzeitGroteskCondensed = "Support-module--tk-neuzeit-grotesk-condensed--88db6";
export var tkNeuzeitGroteskExtraConden = "Support-module--tk-neuzeit-grotesk-extra-conden--c3ec9";
export var topMenuSection = "Support-module--topMenuSection--e06de";
export var wrapper = "Support-module--wrapper--8066b";